import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-81d868e4")

_pushScopeId("data-v-81d868e4")
const _hoisted_1 = { class: "uiTabFramework" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "foot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_a_tabs = _resolveComponent("a-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_a_tabs, {
        type: "card",
        activeKey: _ctx.activeTab,
        "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = $event)),
        onChange: _ctx.handleClick
      }, {
        tabBarExtraContent: _withId(() => [
          _renderSlot(_ctx.$slots, "action")
        ]),
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (t) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              tab: t,
              key: t
            }, null, 8, ["tab"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeKey", "onChange"])
    ]),
    _createVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "content")
    ]),
    _createVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "foot")
    ])
  ]))
})